import { VueConstructor } from 'vue/types/umd';

export default {
  install(Vue: VueConstructor) {
    // Takes a number or string type number and
    // formats to have comma's for every 1000 and shortens to 2 decimal places
    Vue.filter(
      'formatNumToMoney',
      function formatNumToMoney(num: number | string): string {
        const rgx = /\B(?=(\d{3})+(?!\d))/g;
        return typeof num === 'string'
          ? num.replace(rgx, ',')
          : num.toString().replace(rgx, ',');
      },
    );
  },
};

export function handleError(err: any, fallbackText?: string) {
  let msg;
  if (err && err.response && err.response.status && err.response.data && err.response.data.Message) {
    msg = err.response.data.Message.replace(/(\r\n|\n|\r)/g, '<br>');
    msg = msg.replace(
      /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi,
      '<a href="mailto:$1">$1</a>',
    );
  } else {
    msg = fallbackText || 'Sorry, looks like something went wrong.';
  }
  return msg;
}

export function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  if (value instanceof Date) return value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export const errorHelper = (error: any, name: string, accountHolder = '') => {
  return error.map((err: any) => {
    switch (err.type) {
      case 'any.empty':
        return { message: `${accountHolder} ${name} field is required` };
      case 'string.min':
        return {
          message: `${accountHolder} ${name} must have a min character length of ${err.context.limit}`,
        };
      case 'string.max':
        return {
          message: `${accountHolder} ${name} can only have a max character length of ${err.context.limit}`,
        };
      case 'string.length':
        return {
          message: `${accountHolder} ${name} must be ${err.context.limit} characters long`,
        };
      case 'string.email':
        return {
          message: `${accountHolder} ${name} must be a valid email`,
        };
      case 'string.base':
        return {
          message: `${accountHolder} ${name} must be a valid string`,
        };
      default:
        return err;
    }
  });
};